import { createQueryKeys } from 'query-keys';
import { EquipmentId } from '../../../slices/equipments';
import { DeviceSessionId, EquipmentSessionId } from '../../../slices/sessions';

type TracksParams = { equipmentId?: EquipmentId; start?: string; end?: string };

export const sessionQueryKeys = createQueryKeys('sessions', {
  shared: (id: string) => ({ id }),
  forcedOrIgnoredParcels: (deviceSessionId: DeviceSessionId) => ({ deviceSessionId }),
  equipmentSessionPoints: (id?: EquipmentSessionId) => ({ id }),
  equipmentTracks: (params: TracksParams) => params,
  parcelTracks: (params: TracksParams) => params,
});

// reach every equipment and date range cached, since a status change can recompute any of them
export const equipmentTracksKeyPrefix = ['sessions', 'equipmentTracks'];
export const parcelTracksKeyPrefix = ['sessions', 'parcelTracks'];
